import Icon from '../components/Icon';

const ZoomOut = Icon(
  'zoom-out',
  <>
    <path d="M3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z" />
  </>
);

export default ZoomOut;
